import React, { Component } from 'react';
import NFTEditionsLivestream from './NFTEditionsLivestream';
import {FaLock} from 'react-icons/fa';
import superfestlogo from './superfestlogo.png';
import instagramIcon from './InstagramIcon.png';
import spotifyIcon from './SpotifyIcon.png';
import twitterIcon from './TwitterIcon.png';
import discordIcon from './DiscordIcon.png';
import githubIcon from './GithubIcon.png';

class NFTSalesLivestream extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    // TODO clean up hard coded SUPERFEST conditional logic
    return (
      <div>
        <div className="w-screen md:w-[272px] bg-custom-white dark:bg-custom-black border-x-2 border-b-2 dark:border-zinc-800 h-[600px] md:h-[calc(100vh-64px)]">
          <div className="mt-8 sm:mt-0 justify-around flex">
            <div className="flex cursor-pointer mt-10 text-zinc-600">
              <div className={
                this.props.nftSalesLivestream != null && this.props.nftSalesLivestream.type !== "poap"
                  ?
                "text-teal-500 dark:text-teal-400 font-semibold"
                  :
                "text-zinc-600 font-medium"
              }>
                Editions
              </div>
              {
                this.props.nftSalesLivestream != null && this.props.nftSalesLivestream.type === "poap"
                  ?
                <div className="mt-[6px] ml-1 text-zinc-600 text-xs">
                  <FaLock />
                </div>
                  :
                null
              }
            </div>
            <div className="flex cursor-pointer mt-10 text-zinc-600">
              <div className={
                this.props.nftSalesLivestream != null && this.props.nftSalesLivestream.type === "poap"
                  ?
                "text-teal-500 dark:text-teal-400 font-semibold"
                  :
                "text-zinc-600 font-medium"
              }>
                POAPs
              </div>
              {
                this.props.nftSalesLivestream != null && this.props.nftSalesLivestream.type !== "poap"
                  ?
                <div className="mt-[6px] ml-1 text-zinc-600 text-xs">
                  <FaLock />
                </div>
                  :
                null
              }
            </div>
            <div className="flex cursor-pointer mt-10 text-zinc-600">
              <div className="text-zinc-600 font-medium">
                Auctions
              </div>
              <div className="mt-[6px] ml-1 text-zinc-600 text-xs">
                <FaLock />
              </div>
            </div>
          </div>
          {
            this.props.nftSalesLivestream != null
              ?
            <NFTEditionsLivestream
              address={this.props.address}
              setTransactionStatus={this.props.setTransactionStatus}
              nftSalesLivestream={this.props.nftSalesLivestream}
            />
              :
            null
          }
          <div className="ml-8">
            <div className="text-zinc-600 text-md font-semibold mt-[calc(100vh-260px)]">
              PRESENTED BY
            </div>
            <div className="flex items-center mt-2">
              <img className="w-14 h-14 rounded-full border-zinc-800 border-2"src={superfestlogo}/>
              <div className="ml-4">
                <div className="text-black dark:text-white font-semibold">
                  SUPERF3ST
                </div>
                <div className="flex">
                    <img
                      onClick={()=> window.open("https://www.instagram.com/superf3st/", "_blank")}
                      className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2 ml-2" src={instagramIcon}
                    />
                    <img
                      onClick={()=> window.open("https://twitter.com/SUPERF3ST", "_blank")}
                      className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2 ml-2" src={twitterIcon}
                    />
                    <img
                      onClick={()=> window.open("https://discord.com/invite/superf3st", "_blank")}
                      className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[22px] mt-2 ml-2" src={discordIcon}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NFTSalesLivestream;
